import React from "react";
import styled from "styled-components";

const Inner = styled.div`
  max-width: ${({ wide }) => (wide ? "none" : "75rem")};
  margin: 0 auto;

  b {
    color: white;
  }

  p,
  ul,
  ol {
    max-width: ${({ wide }) => (wide ? "none" : "68ch")};
  }

  p {
    font-size: var(--font-size-heading-x-small);
    &:last-child {
      margin: 0;
    }
  }

  a {
    color: white;
    border-color: rgba(255, 255, 255, 0.2);
    &:hover,
    &:visited {
      color: #ff73df;
    }
  }

  ol,
  ul {
    font-size: var(--font-size-heading-tiny);
    margin-top: var(--spacing-medium);
    margin-bottom: var(--spacing-x-medium);
  }
  ol:last-child,
  ul:last-child {
    margin-bottom: var(--spacing-clear);
  }

  ol li:last-child,
  ul li:last-child {
    margin-bottom: var(--spacing-clear);
  }

  div {
    margin-bottom: 0;
  }

  /* Page Title */
  h1 {
    padding-top: var(--spacing-medium);
    margin-bottom: ${({ wide }) => (wide ? "var(--spacing-x-medium)" : "var(--spacing-medium)")};
  }

  h2 {
    margin-bottom: var(--spacing-small);
  }

  h4 {
    margin-top: var(--spacing-clear);
    margin-bottom: var(--spacing-small);
    color: #ff73df;
  }

  h3 {
    margin-bottom: var(--spacing-small);
  }

  figure:not(:last-child) {
    margin-bottom: ${({ wide }) => (wide ? "var(--spacing-clear)" : "var(--spacing-medium)")};
  }
`;

const BlogLayout = ({ children, className, wide = false }) => {
  return (
    <Inner className={className} wide={wide}>
      {children}
    </Inner>
  );
};

export default BlogLayout;
